import CrossSellGalleryElement from './CrossSellGalleryElement';
import CrossSellGalleryElementPresets from './CrossSellGalleryElementPresets';
import CrossSellGalleryElementMetaData from './CrossSellGalleryElementMetaData';
import CrossSellGalleryElementProps from './CrossSellGalleryElementProps';
import { getInteractiveElements, refreshInteractiveElementsList } from './CrossSellGalleryElement';
import { DATA_PANELS } from 'crazyEditor/core/constants/panelConstants';

export default {
  metaData: CrossSellGalleryElementMetaData,
  elementClass: CrossSellGalleryElement,
  elementProps: CrossSellGalleryElementProps,
  presets: CrossSellGalleryElementPresets,
  methods: { getInteractiveElements, refreshInteractiveElementsList },
  panel: DATA_PANELS.CROSS_SELL_GALLERY
};
